import React from 'react';
import { CButton, CCard, CCardHeader, CCol, CDataTable, CRow } from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';
import { UserRoles } from '../../shared/models/user';
import { selectUserOrganization, selectUserOrganizationLoadingStatus } from '../../store/selectors/store.selectors';
import { Organization } from '../../shared/models/organization';
import { selectUserProfile } from '../../store/selectors/profile.selectors';
import { ModalName } from '../../shared/models/modal';
import { OpenModal } from '../../store/actions/modal.action';

const getOrgTableData = (org: Organization) => org ? [{
  key: 'ID',
  value: org._id
}, {
  key: 'Organization Name',
  value: org.name
}] : [];

const OrganizationDetails = () => {

  const dispatch = useDispatch();
  const user = useSelector(selectUserProfile);
  const org = useSelector(selectUserOrganization);
  const isLoading = useSelector(selectUserOrganizationLoadingStatus);

  const isAdmin = user?.roles.indexOf(UserRoles.Admin) > -1;

  const UserColumnRenderer = ({ key, value }) => {
    switch (key) {
      default:
        return (
          <strong>
            {value}
          </strong>
        );
    }
  };

  return (
    <CRow>
      <CCol>
        <CCard className="glympser-container--roundedWithShadow mt-5 pt-3">
          <div className='glympser-roundedTop glympser-bottomBorder glympser-cardTitle'>Organization</div>
          {
            isAdmin ? (
              <CCardHeader>
                <div className="card-header-actions">
                  <CButton type="button" color="primary" className="mr-1 bg-color-orange border-0 roundedBtn" onClick={ () => dispatch(new OpenModal(ModalName.EditOrg, { org })) }>Edit</CButton>
                </div>
              </CCardHeader>
            ) : null
          }
          <div className='job-list-container'>
            <CDataTable
              items={getOrgTableData(org)}
              header={false}
              hover
              striped
              loading={isLoading}
              scopedSlots = {{
                'value':
                  (item) => <td>
                    {UserColumnRenderer(item)}
                  </td>
              }}
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default OrganizationDetails;
